
import { BrowserRouter } from 'react-router-dom';
import { PriceMonitorProvider } from './hooks/usePriceMonitor';
import { FavoritesProvider } from './hooks/useFavorites';
import { AppRoutes } from './router/index';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <PriceMonitorProvider>
        <FavoritesProvider>
          <div className="min-h-screen bg-white">
            <AppRoutes />
          </div>
        </FavoritesProvider>
      </PriceMonitorProvider>
    </BrowserRouter>
  );
}

export default App;
